module.exports = __webpack_public_path__ + "img/0603-q.05707238.svg";